import {sendTestPushNotification,requestPushPermission,subscribeUserIOS,isUserSubscribed} from "../../utils/push_notifications"
import {Button, Message} from "semantic-ui-react"
import React, { Component } from "react";

class PushNotificationWindow extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.state = {
        isSubscribed:false,
        pushClosed:false,
        isIOS:false
    };

  }

   componentDidMount() {
  // Load user safely
  const userRaw = localStorage.getItem("user");
   const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  if (userRaw) {
    const user = JSON.parse(userRaw);
    this.setState({
      userRole: user.role,
      userId: user.user_id,
      isIOS:isIOS
    });
  }

  // Check push subscription status
  isUserSubscribed().then(isSubscribed => {
    this.setState({ isSubscribed });
  });


  // 🔒 SAFETY NET:
  // If notifications are denied, ensure no stale push subscription exists
  if ("Notification" in window && Notification.permission === "denied") {
    navigator.serviceWorker.ready
      .then(reg => reg.pushManager.getSubscription())
      .then(sub => {
        if (sub) {
          console.warn("Unsubscribing stale push subscription");
          return sub.unsubscribe();
        }
      })
      .catch(err => {
        console.error("Push cleanup failed:", err);
      });
  }
}

 



  render() {
    return (
      <div>
            { !this.state.pushClosed  && this.state.userRole !== "agent"&& (
  <Message style={{margin:"auto", marginTop:"10px",maxWidth:"500px",}} textAlign="center" warning>
    {this.state.isSubscribed && <React.Fragment><Message.Header>You are subscribed to Push Notifications   </Message.Header> <hr/> <div style={{textAlign:"center"}}><Button  align="center"style={{margin:"auto"}} color="red" onClick={() => {this.setState({pushClosed:true})}}>Close Window</Button> <Button color="yellow" onClick={()=>sendTestPushNotification()}>Send test notification</Button> </div> </React.Fragment>}
{!this.state.isSubscribed &&<React.Fragment>

    <Message.Header>You are not subscribed to notifications</Message.Header>
  
    <p>You haven’t enabled push notifications yet. Click below to subscribe.</p>
    <div style={{textAlign:"center"}}><Button  align="center"style={{margin:"auto"}} color="red" onClick={() => {this.setState({pushClosed:true})}}>Close Window</Button> <hr/>
{ !this.state.isIOS  ?   <Button style={{margin:"auto"}} color="yellow" onClick={requestPushPermission}>Subscribe to Push Notifications</Button> : <div>
    <Button style={{margin:"auto"}} color="yellow" onClick={subscribeUserIOS}>Subscribe to Push Notifications (IOS)</Button><hr/>
    <Message>
        The following process must be done to enable Notifications on iPhone:
        <ol>
           <li>(iOS 16.4+ REQUIRED) Open this site in Safari</li>
           <li>Tap Share - Add to Home Screen</li>
           <li>Open the App from the Home Screen icon (REQUIRED)</li>
           <li>Click the Subscribe button.</li>
            </ol>
    </Message>
    </div>} </div></React.Fragment>}</Message>
)}
      </div>
    );
  }
}

export default PushNotificationWindow;


// WEBPACK FOOTER //
// ./src/views/dashboard/push_notification_window.js